import { createContext, useContext, useState, ReactNode, useCallback } from 'react';
import { useNavigate } from 'react-router';

interface MiniSidebarContextType {
  mobileOpen: boolean;
  toggleMobile: () => void;
  closeMobile: () => void; // Add this
  customNavigate: (to: string | URL) => void;
}

const MiniSidebarContext = createContext<MiniSidebarContextType | undefined>(undefined);

export const MiniSidebarProvider = ({ 
  children, 
  onSiteSelectionNavigation 
}: { 
  children: ReactNode;
  onSiteSelectionNavigation?: () => void;
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobile = useCallback(() => {
    setMobileOpen(prev => !prev);
  }, []);

  const closeMobile = useCallback(() => {
    setMobileOpen(false);
  }, []);


  const customNavigate = (to: string | URL) => {
    // Extract the path from the navigation target
    const targetPath = typeof to === 'string' ? to : to.pathname || to.toString();

    // Extract the first segment from the path
    const segments = targetPath.split('/').filter(Boolean);
    const firstSegment = segments[0];

    // Check if the segment is 'site-selection'
    if (firstSegment === 'site-selection') {
      // Cancel default navigation and call your custom method
      console.log('Intercepting site-selection navigation from MiniSidebar');
      if (onSiteSelectionNavigation) {
        onSiteSelectionNavigation();
      }
      return; // Don't proceed with navigation
    }

    // For all other segments, proceed with normal navigation
    navigate(to);
    
    // Close mobile sidebar after navigation
    if (mobileOpen) {
      closeMobile();
    }
  };

  return (
    <MiniSidebarContext.Provider value={{ mobileOpen, toggleMobile, closeMobile, customNavigate }}>
      {children}
    </MiniSidebarContext.Provider>
  );
};

export const useMiniSidebar = () => {
  const context = useContext(MiniSidebarContext);
  if (!context) {
    throw new Error('useMiniSidebar must be used within MiniSidebarProvider');
  }
  return context;
};